import { Component, OnInit, Inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./../base.service";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
@Component({
  selector: "app-report-abuse",
  templateUrl: "./report-abuse.component.html",
  styleUrls: ["./report-abuse.component.css"],
})
export class ReportAbuseComponent implements OnInit {
  disabledStatus: boolean;
  model: any = {};
  constructor(
    private baseService: BaseService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ReportAbuseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.model.title = "Unwanted commercial content or spam";
  }
  addReport(valid) {
    if (valid) {
      this.model.content_id = this.data.public_id;
      this.model.type = this.data.type;
      this.disabledStatus = true;

      this.baseService.addReport(this.model).subscribe(
        (res) => {
          this.disabledStatus = false;
          this.toastr.success(res.message, "Success!", {
            closeButton: true,
          });
          this.dialogRef.close();
        },
        (err) => {
          this.disabledStatus = false;
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
}
